<template>
  <div
    id="page-login"
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <template #no-body>
          <div class="full-page-bg-color">
            <div class="vx-row no-gutter justify-center items-center">
              <div class="vx-col hidden lg:block lg:w-1/2">
                <img
                  src="@/assets/images/logo/ubunbase_login.png"
                  alt="ubun base"
                  class="responsive"
                />
              </div>
              <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
                <div
                  v-if="isExpired"
                  class="p-8"
                >
                  登録の期限が切れました
                </div>
                <div
                  v-else
                  class="p-8"
                >
                  <h4 class="mb-4">
                    Ubun BASE 新規ユーザー作成
                  </h4>
                  <ValidationForm
                    ref="registerObserver"
                    as="form"
                  >
                    <email-field
                      v-model="email"
                      class="mt-8"
                      rules="required|email"
                      full-width
                      :disabled="true"
                      @keydown.enter="onKeydownEnter"
                    />
                    <password-field
                      v-model="password"
                      name="パスワード"
                      class="mt-8"
                      rules="required|min:5|max:20"
                      full-width
                      @keydown.enter="onKeydownEnter"
                    />
                    <password-field
                      v-model="passwordConfirm"
                      class="mt-8"
                      name="パスワード（確認）"
                      rules="required|confirmed:@パスワード"
                      full-width
                      @keydown.enter="onKeydownEnter"
                    />
                    <div class="mt-8">
                      Ubun BASE利用規約は<a
                        href="https://ubunbase.ubun.jp/policy/"
                        target="_blank"
                      >こちら</a>
                      <vs-checkbox
                        v-model="agreeToTermsOfUse"
                        class="my-2"
                      >
                        利用規約に同意します。
                      </vs-checkbox>
                    </div>
                    <vs-button
                      class="w-full my-8"
                      :disabled="registerDisabled"
                      @click="onRegisterClick"
                    >
                      登録
                    </vs-button>
                  </ValidationForm>
                </div>
              </div>
            </div>
          </div>
        </template>
      </vx-card>
    </div>
  </div>
</template>

<script>

import { mapActions, mapState } from 'vuex'
import moment from 'moment'
import EmailField from '@/components/fields/EmailField'
import PasswordField from '@/components/fields/PasswordField'

export default {
  name: 'UserInvite',
  components: {
    PasswordField,
    EmailField
  },
  data () {
    return {
      userIvite: {},
      token: '',
      email: '',
      password: '',
      passwordConfirm: '',
      accountId: '',
      agreeToTermsOfUse: false,
      registerDisabled: true,
      isExpired: false,
      vendorUrl: `${process.env.VUE_APP_VENDOR_API_URL}/register`
    }
  },
  computed: {
    ...mapState(['globalError', 'requestingStatus'])
  },
  watch: {
    agreeToTermsOfUse (value) {
      this.registerDisabled = !value
    },
    globalError: {
      deep: true,
      handler ({ message }) {
        this.$vs.notify({
          position: 'top-center',
          color: 'danger',
          text: message,
          fixed: true
        })
      }
    }
  },
  async mounted () {
    try {
      this.token = this.$route.params.token
      const result = await this.getUserInvite({token:this.token})
      if (result) {
        this.userIvite = result.data.data
        if (this.userIvite) {
          this.email = this.userIvite.email
          this.accountId = this.userIvite.accountId
          const expiresDate  = moment(this.userIvite.expiresDate)
          const toDay = moment(new Date())
          if (toDay.isAfter(expiresDate)) {
            this.isExpired = true
          }
        } else {
          this.isExpired = true
        }
      } else {
        this.isExpired = true
      }
    } catch (e) {
      console.log(e)
    }
  },
  methods: {
    ...mapActions('user', ['addUser']),
    ...mapActions('userInvite', ['getUserInvite', 'deleteUserInvite']),
    onKeydownEnter (event) {
      event.stopPropagation()
      event.preventDefault()
      // 日本語入力中のEnterキー操作は無効にする
      if (event.keyCode !== 13) return
      this.onRegisterClick()
    },
    async onRegisterClick () {
      const isValid = await this.$refs.registerObserver.validate()
      if (!isValid.valid || !this.agreeToTermsOfUse) return
      try {
        await this.addUser({
          token: this.token,
          password_confirm: this.passwordConfirm,
          email: this.email,
          password: this.password,
          account_id: this.accountId
        })
        await this.deleteUserInvite({ token: this.token })
        await this.$router.push('/').catch(() => {})
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style lang="scss"></style>
